module.exports = __webpack_public_path__ + "img/f2-1.c61b3aa5.png";